define('areas/organizationmanager/commands/resendactivationcommand',["require", "exports", "services/trace", "services/httpclient"], function (require, exports, Trace, Http) {
    "use strict";
    var ResendActivationCommand = (function () {
        function ResendActivationCommand(taskManager) {
            this._taskManager = taskManager;
        }
        ResendActivationCommand.prototype.execute = function (organization) {
            try {
                var httpClient = new Http.Channel();
                this._taskManager.startAsync("Portalaktivierungsnachricht wird gesendet...", function () {
                    return httpClient.putDataAsync("/api/organization/resendportalactivation?organizationId=" + organization.id, Http.ServiceTarget.portalApi, null).
                        then(function (data) {
                        Trace.traceInformation("Die Nachricht wurde erfolgreich verschickt.");
                    }).fail(function (error) {
                        Trace.traceError(error.responseJSON.Message, null, "organizationmanager:index", true);
                    });
                });
            }
            catch (exception) {
                Trace.traceError(exception, null, "organizationmanager:index", true);
            }
        };
        return ResendActivationCommand;
    }());
    return ResendActivationCommand;
});

